import mixpanel from 'mixpanel-browser';

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    mixpanel.init('abea54652536a3d22e86e0634b0de56f', {
        persistence: "localStorage",
        record_sessions_percent: 100,
        record_block_selector: '',
        record_mask_text_selector: ''
    });
} else if (process.env.REACT_APP_ENVIRONMENT === 'stage') {
    mixpanel.init('1b6cbf7fd4641052e95b117525822d37', {
        persistence: "localStorage",
        record_sessions_percent: 100,
        record_block_selector: '',
        record_mask_text_selector: ''
    });
} else if (process.env.REACT_APP_ENVIRONMENT === 'development') {
    mixpanel.init("b3eb503e124a6c65cb8b0098ad606209", {
        debug: true,
        persistence: "localStorage",
        record_sessions_percent: 100,
        record_block_selector: '',
        record_mask_text_selector: ''
    });
}

let actions = {
    identify: (id) => {
        mixpanel.identify(id);
    },
    alias: (id) => {
        mixpanel.alias(id);
    },
    track: (name, props) => {
        mixpanel.track(name, props);
    },
    register: (props) => {
        mixpanel.register(props);
    },
    reset: (props) => {
        mixpanel.reset();
    },
    people: {
        set: (props) => {
            mixpanel.people.set(props);
        }
    },
    track_links: () => {
        mixpanel.track_links('#root a', 'Nav link clicked', {
            referrer: document.referrer
        });
    }
};

export let Mixpanel = actions;
